import './red-page.css'
import mapeoImage from '../assets/img/general/Mapeo2026.png'

const networkWays = [
  {
    title: 'Grupo de whatsapp de cultura menstrual',
    text: 'Cuidamos de este grupo donde hay más de cien mujeres que han solicitado unirse para compartir artículos, eventos o reflexiones.'
  },
  {
    title: 'Reuniones de trabajo para la reflexión y acción a nivel internacional',
    text: 'Vínculos con personas, proyectos y organizaciones de otros países comprometidas con la justicia menstrual.'
  },
  {
    title: 'Entidades afines',
    text: 'Colaboración presencial u online con organizaciones que comparten valores y objetivos en torno a la cultura menstrual.'
  }
]

const collaborators = [
  'La Fundación Instituto Universitario para la investigación en la Atención Primaria de Salud Jordi Gol i Gurina (IDIAPJGol)',
  'Centro de Inserción Social Josefina Aldecoa, Madrid',
  'Xarxa de Dones per la Salut, Catalunya',
  'Viquiprojecte: Dones i Salut',
  'Caps (Centro de Análisis y Programas Sanitarios)',
  'Cooperativa Espai Brotes SCCL'
]

const RedPage = () => {
  return (
    <section className='red-page section__padding' id='red-page'>
      <a className='red-page__back-link' href='/asociacion'>
        <span aria-hidden='true'>←</span>
        Volver
      </a>

      <header className='red-page__hero'>
        <h1 className='red-page__title'>Red</h1>
        <p className='red-page__lead'>
          Nuestra acción crece siempre con el deseo de <strong>estar en relación y generar complicidades</strong> que van más allá de nuestra asociación, a través de reflexiones, aportes y alianzas con compañeras y entidades de otros proyectos educativos, de investigación y de acción. Juntas trabajamos para <strong>democratizar los cuidados, combatir la pobreza menstrual y contribuir a erradicar las violencias machistas, avanzar en igualdad de género, equidad laboral y reconocimiento de la diversidad de experiencias</strong>, a escala estatal, europea e internacional.
        </p>
        <p className='red-page__lead'>
          Esta <strong>red, orgánica, viva y en constante crecimiento</strong>, es la base de todo lo que hacemos.
        </p>
      </header>

      <section className='red-page__section' aria-labelledby='red-page-network-title'>
        <div className='red-page__section-heading'>
          <span>Trabajo compartido</span>
          <h2 id='red-page-network-title'>Cómo trabajamos en red</h2>
        </div>

        <div className='red-page__network'>
          {networkWays.map((item) => (
            <article key={item.title} className='red-page__card'>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </section>

      <div className='red-page__section'>
        <div className='red-page__section-heading'>
          <span>Colaboración</span>
          <h2>Colaboramos con</h2>
        </div>

        <ul className='red-page__list'>
          {collaborators.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      <div className='red-page__highlight'>
        <p>Entidad miembra del Consell Nacional de les Dones de Catalunya (CNDC).</p>
      </div>

      <div className='red-page__section red-page__section--mapping'>
        <div className='red-page__mapping-copy'>
          <div className='red-page__section-heading'>
            <span>Cartografía</span>
            <h2>Mapeo: Red de Educadoras Menstruales Península Ibérica e islas</h2>
          </div>
          <p className='red-page__caption'>Año de recogida de información: 2024-2025</p>
          <p>
            Los objetivos principales de este mapeo son visibilizar la presencia de educadoras menstruales en la Península Ibérica e islas, facilitar la conexión entre profesionales y colectivos, y reforzar una red de intercambio y apoyo en torno a la educación menstrual.
          </p>
          <p className='red-page__attribution'>
            La idea de “mapeo” la tomamos de las compañeras de la Red de Educación Menstrual, México (REM):{' '}
            <a href='https://educadorasmenstruales.redmenstrual.com/' target='_blank' rel='noreferrer'>https://educadorasmenstruales.redmenstrual.com/</a>
          </p>
          <a className='red-page__button' href='https://www.google.com/maps/d/u/1/viewer?mid=1iM-XrUjpd-cfhn_B--UGSNwtj7CwndI&ll=40.23628676554146%2C-3.3714358880985174&z=6' target='_blank' rel='noreferrer'>
            Consulta el mapa de las educadoras menstruales
          </a>
        </div>

        <div className='red-page__mapping-image'>
          <img src={mapeoImage} alt='Mapeo educadoras menstruales' />
        </div>
      </div>
    </section>
  )
}

export default RedPage
